/* eslint import/prefer-default-export: 0 */

import { get } from 'lodash';

export const resolveRouteData = ({ routeData, store }) => {
  const state = store.getState();
  const { componentData } = { ...routeData };
  const data = {};
  componentData.forEach(elem => {
    data[elem.key] = get(state, elem.accessor);
  });
  return data;
};
